import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=716f9e46&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"
import style0 from "./NewsSection.vue?vue&type=style&index=0&id=716f9e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f9e46",
  null
  
)

export default component.exports